// extracted by mini-css-extract-plugin
export default {"resetLink":"reset-link_resetLink__wu7oa","placeHolderShimmer":"reset-link_placeHolderShimmer__w2WOS"};